export const initState = {
  orderType: "1", // Default order type
  isDiscount: false, // Default discount state
  selectedDiscountType: "",
  selectedPaymentMethod: "",
  selectedSeat: {},
  selectedSeatType: "",
  selectedSeatPrice: 0, // Default seat price
  selectedQuantity: 1, // Default quantity
  totalAmount: 0, // Default total amount
  discountTypes: [], // Array to hold discount types
  seats: [],
  uniqueSeats: [], // Array to hold seat options
  seatTypes: [], // Array to hold seat types
  seatsTime: [], // Array to hold show times
  paymentMethods: [], // Array to hold payment methods
  loading: false, // Loading state
  loadingText: "", // Loading text
};
export default function reducer(state, action) {
  switch (action.type) {
    case "SET_ORDER_TYPE": {
      return { ...state, orderType: action.value };
    }
    case "IS_DISCOUNT": {
      return { ...state, isDiscount: action.value };
    }
    case "SET_SELECTED_SEAT": {
      return { ...state, selectedSeat: action.value };
    }
    case "SET_SELECTED_DISCOUNT_TYPE": {
      return { ...state, selectedDiscountType: action.value };
    }
    case "SET_SELECTED_QUANTITY": {
      return { ...state, selectedQuantity: action.value };
    }
    case "SET_TOTAL_AMOUNT": {
      return { ...state, totalAmount: action.value };
    }
    case "SET_SELECTED_PAYMENT_METHOD": {
      return { ...state, selectedPaymentMethod: action.value };
    }
    case "SET_SELECTED_SEAT_TYPE": {
      return { ...state, selectedSeatType: action.value };
    }
    case "SET_SELECTED_SEAT_PRICE": {
      return { ...state, selectedSeatPrice: action.value };
    }
    case "SET_DISCOUNT_TYPES": {
      return { ...state, discountTypes: action.value };
    }
    case "SET_ALL_SEATS": {
      return { ...state, seats: action.value };
    }
    case "SET_SEATS": {
      return { ...state, uniqueSeats: action.value };
    }
    case "SET_SEATS_TIME": {
      return { ...state, seatsTime: action.value };
    }
    case "SET_SEAT_TYPES": {
      return { ...state, seatTypes: action.value };
    }
    case "SET_PAYMENT_METHODS": {
      return { ...state, paymentMethods: action.value };
    }
    case "SET_LOADING": {
      return { ...state, loading: action.value };
    }
    case "SET_LOADING_TEXT": {
      return { ...state, loadingText: action.value };
    }
    case "RESET_STATE": {
      return { ...initState };
    }
    default:
      return state;
  }
}
